import { IcoVehicleCar } from "assets/icons";
import { getInitials } from "utils/functions";
import { AssignmentInfoProps } from "./types";

import styles from "./styles.module.scss";

export default function AssignmentInfo({
	vehicle,
	driver
}: AssignmentInfoProps) {
	const initials = getInitials(driver?.name);

	const maskedPlateNumber = `${vehicle?.plate_number?.slice(
		0,
		2
	)}***${vehicle?.plate_number?.slice(-2)}`;

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				{vehicle?.photo ? (
					<div className={styles.image}>
						<img src={vehicle.photo} alt={vehicle.vehicle_model?.name} />
					</div>
				) : (
					<div className={styles.noimage}>
						<IcoVehicleCar />
					</div>
				)}
				<div className={styles.info}>
					<span>{vehicle?.vehicle_model?.name}</span>
					<div className={styles.details}>
						<span>
							{vehicle?.seats} {vehicle?.seats === 1 ? "lugar" : "lugares"}
						</span>
						{" - "}
						<span>{vehicle?.color}</span>
						{" - "}
						<span>{maskedPlateNumber}</span>
					</div>
				</div>
			</div>
			<div className={styles.content}>
				{driver?.photo ? (
					<div className={styles.image}>
						<img src={driver.photo} alt={driver.name} />
					</div>
				) : (
					<div className={styles.noimage}>
						<span>{initials}</span>
					</div>
				)}
				<div className={styles.info}>
					<span>{driver?.name}</span>
					<span>{driver?.driver_license}</span>
				</div>
			</div>
		</div>
	);
}
